import './Animation.scss'

import React, { useEffect, useRef } from 'react'

import type { AnimationType } from '../Asset'
export const Animation: React.FC<AnimationType & { resetOnPause?: boolean }> = ({
  title,
  url,
  loop,
  forcePause,
  className,
  resetOnPause,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const updatePlayback = async () => {
      try {
        if (forcePause) {
          videoRef.current?.pause()
          if (resetOnPause) {
            videoRef.current!.currentTime = 0
          }
        } else {
          await videoRef.current?.play()
        }
      } catch (err) {
        console.warn('Video playback error:', err)
      }
    }
    const frame = requestAnimationFrame(updatePlayback)
    return () => cancelAnimationFrame(frame)
  }, [forcePause, resetOnPause])

  return (
    <video
      autoPlay={true}
      className={className || 'coral-animation'}
      loop={loop}
      muted={true}
      playsInline={true}
      ref={videoRef}
      src={url}
      title={title}
    />
  )
}
